import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div data-testid="loading-screen" className="min-h-screen flex items-center justify-center" style={{ background: '#141210' }}>
        <div className="text-center">
          <p style={{ fontFamily: "'Playfair Display', serif", color: '#c4956a', fontSize: '1.5rem' }}>ECHO</p>
          <div className="mt-4 w-8 h-8 border-2 border-t-transparent rounded-full animate-spin mx-auto" style={{ borderColor: '#c4956a', borderTopColor: 'transparent' }} />
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return children;
}
